/* Livostyle Stories viewer — tap-through vertical stories (no dependencies). */
(function () {
  if (window.LivoStories) return;
  var DATA_URL = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?section_id=livo-stories-data';
  var SEEN_KEY = 'livo_st_seen';
  var packs = null, loading = null, el = null, pi = 0, si = 0;
  var dur = 5000, t0 = 0, acc = 0, paused = true, raf = 0, curBar = null, video = null, opened = false;

  function $(s, r) { return (r || document).querySelector(s); }
  function seen() { try { return JSON.parse(localStorage.getItem(SEEN_KEY) || '[]'); } catch (e) { return []; } }
  function markSeen(h) { try { var s = seen(); if (s.indexOf(h) < 0) { s.push(h); localStorage.setItem(SEEN_KEY, JSON.stringify(s)); } } catch (e) {} paintSeen(); }
  function paintSeen() { var s = seen(); document.querySelectorAll('[data-story]').forEach(function (a) { a.classList.toggle('is-seen', s.indexOf(a.dataset.story) > -1); }); }
  function track(name, p) { try { if (window.gtag) gtag('event', name, p); } catch (e) {} }

  function load() {
    if (packs) return Promise.resolve(packs);
    if (loading) return loading;
    loading = fetch(DATA_URL, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var s = d.getElementById('LivoStoriesData');
      packs = JSON.parse(s ? s.textContent : '[]').filter(function (p) { return p.s && p.s.length; });
      return packs;
    });
    return loading;
  }

  function build() {
    el = document.createElement('div');
    el.className = 'lsv'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', 'Stories');
    el.innerHTML = '<div class="lsv__bg"></div>' +
      '<button class="lsv__nav lsv__nav--prev" aria-label="Previous story"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg></button>' +
      '<div class="lsv__stage"><div class="lsv__spin"></div><div class="lsv__slot"></div>' +
      '<div class="lsv__top"><div class="lsv__bars"></div><div class="lsv__head"><span class="lsv__av"></span><span class="lsv__ttl"></span><span class="lsv__brand">Livostyle</span>' +
      '<button class="lsv__x" aria-label="Close stories"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div></div>' +
      '<button class="lsv__tap lsv__tap--prev" aria-label="Previous"></button><button class="lsv__tap lsv__tap--next" aria-label="Next"></button>' +
      '<div class="lsv__over"></div></div>' +
      '<button class="lsv__nav lsv__nav--next" aria-label="Next story"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2"><path d="M9 6l6 6-6 6"/></svg></button>';
    document.body.appendChild(el);
    $('.lsv__x', el).addEventListener('click', close);
    $('.lsv__nav--prev', el).addEventListener('click', function () { goPack(pi - 1, 0); });
    $('.lsv__nav--next', el).addEventListener('click', function () { goPack(pi + 1, 0); });
    gestures($('.lsv__stage', el));
    document.addEventListener('keydown', function (e) {
      if (!opened) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    });
    document.addEventListener('visibilitychange', function () { if (opened) (document.hidden ? pause() : resume()); });
  }

  function gestures(stage) {
    var x0, y0, tStart, holdT, held = false, active = false;
    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('a')) return;
      active = true; held = false; x0 = e.clientX; y0 = e.clientY; tStart = Date.now();
      holdT = setTimeout(function () { held = true; pause(); el.classList.add('is-paused'); }, 220);
    });
    stage.addEventListener('pointerup', function (e) {
      if (!active) return; active = false; clearTimeout(holdT);
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (held) { held = false; el.classList.remove('is-paused'); resume(); return; }
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { goPack(dx < 0 ? pi + 1 : pi - 1, 0); return; }
      if (dy > 90) { close(); return; }
      if (e.target.closest('.lsv__x, .lsv__nav')) return;
      var r = stage.getBoundingClientRect();
      if (e.clientX - r.left < r.width * 0.32) prev(); else next();
    });
    stage.addEventListener('pointercancel', function () { active = false; clearTimeout(holdT); if (held) { held = false; el.classList.remove('is-paused'); resume(); } });
    stage.addEventListener('click', function (e) {
      var t = e.target.closest('.lsv__tap'); if (!t) return;
      e.preventDefault();
      if (e.detail === 0) { if (t.classList.contains('lsv__tap--prev')) prev(); else next(); } /* keyboard activation */
    });
  }

  function open(handle) {
    if (!el) build();
    if (!opened) {
      opened = true; document.documentElement.classList.add('lsv-lock');
      $('.lsv__slot', el).innerHTML = ''; $('.lsv__over', el).innerHTML = '';
      el.style.display = 'flex'; requestAnimationFrame(function () { el.classList.add('is-open'); });
      if (!(history.state && history.state.lsv)) history.pushState({ lsv: 1 }, '', '#story=' + handle);
    }
    load().then(function (ps) {
      if (!opened) return;
      if (!ps.length) { close(); return; }
      var i = 0; ps.forEach(function (p, k) { if (p.h === handle) i = k; });
      goPack(i, 0);
    }).catch(function () { loading = null; close(); });
  }

  function close(fromPop) {
    if (!opened) return;
    opened = false; stop(); el.classList.remove('is-open');
    document.documentElement.classList.remove('lsv-lock');
    setTimeout(function () { if (!opened) { el.style.display = 'none'; $('.lsv__slot', el).innerHTML = ''; } }, 200);
    if (fromPop !== true && history.state && history.state.lsv) history.back();
  }

  function goPack(i, s) {
    if (i < 0) { i = 0; s = 0; }
    if (i >= packs.length) { close(); return; }
    pi = i; var p = packs[pi];
    markSeen(p.h); track('view_story', { story_pack: p.h });
    $('.lsv__ttl', el).textContent = p.t;
    $('.lsv__av', el).innerHTML = p.c ? '<img src="' + p.c + '" alt="">' : '';
    $('.lsv__bg', el).style.backgroundImage = p.c ? 'url(' + p.c + ')' : '';
    $('.lsv__bars', el).innerHTML = p.s.map(function () { return '<span class="lsv__bar"><i></i></span>'; }).join('');
    try { history.replaceState({ lsv: 1 }, '', '#story=' + p.h); } catch (e) {}
    show(s || 0);
  }

  function next() { var p = packs[pi]; if (si + 1 < p.s.length) show(si + 1); else goPack(pi + 1, 0); }
  function prev() { if (si > 0) show(si - 1); else if (pi > 0) goPack(pi - 1, 0); else show(0); }

  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function show(i) {
    stop(); si = i;
    var p = packs[pi], s = p.s[si];
    var bars = el.querySelectorAll('.lsv__bar');
    bars.forEach(function (b, k) { b.classList.toggle('is-done', k < si); b.firstChild.style.width = k < si ? '100%' : '0'; });
    curBar = bars[si] ? bars[si].firstChild : null;
    var slot = $('.lsv__slot', el), over = $('.lsv__over', el);
    slot.innerHTML = ''; over.innerHTML = ''; video = null;
    var media;
    if (s.k === 'p' && s.v) {
      media = document.createElement('video');
      media.muted = true; media.playsInline = true; media.setAttribute('playsinline', ''); media.preload = 'auto';
      media.poster = s.src || ''; media.src = s.v; video = media;
      media.addEventListener('loadedmetadata', function () { if (media.duration && isFinite(media.duration)) dur = Math.min(Math.max(media.duration * 1000, 4000), 15000); });
      media.addEventListener('playing', function () { if (paused && opened) start(); }, { once: true });
      media.addEventListener('error', function () { start(6000); });
      var pr = media.play(); if (pr && pr.catch) pr.catch(function () { start(6000); });
      dur = 8000;
    } else if (s.k === 'c') {
      media = document.createElement('div'); media.className = 'lsv__media';
      media.style.cssText = 'background:#111 center/cover no-repeat;background-image:url(' + (s.bg || '') + ');filter:blur(18px) brightness(.55);transform:scale(1.15)';
      over.innerHTML = '<div class="lsv__cta"><span class="lsv__cta-av">' + (p.c ? '<img src="' + p.c + '" alt="">' : '') + '</span><h3>' + esc(s.t) + '</h3>' +
        '<a class="lsv__btn" href="' + esc(s.u) + '" data-track="cta">' + esc(s.l) + ' &rarr;</a></div>';
      setTimeout(function () { start(6000); }, 50);
    } else {
      media = new Image(); media.alt = s.alt || s.n || ''; media.decoding = 'async';
      media.onload = function () { start(s.k === 'p' ? 6000 : 5000); };
      media.onerror = function () { start(3000); };
      media.src = s.src;
    }
    media.classList.add('lsv__media');
    if (s.k === 'i') media.classList.add('is-fit');
    $('.lsv__stage', el).classList.toggle('is-fit', s.k === 'i');
    slot.appendChild(media);
    if (s.k === 'p') {
      over.innerHTML = '<div class="lsv__info"><p class="lsv__name">' + esc(s.n) + '</p><div class="lsv__price">' + esc(s.pr) + (s.cp ? '<s>' + esc(s.cp) + '</s>' : '') + '</div>' +
        '<a class="lsv__btn" href="' + esc(s.u) + '" data-track="product">Shop now &rarr;</a></div>';
    }
    var a = over.querySelector('a[data-track]');
    if (a) a.addEventListener('click', function () { track('select_story_item', { story_pack: p.h, kind: a.dataset.track, url: a.getAttribute('href') }); });
    var n = p.s[si + 1]; if (n && n.src && !n.v) { var pre = new Image(); pre.src = n.src; }
  }

  function start(d) { if (d) dur = d; acc = 0; paused = true; resume(); }
  function resume() { if (!opened || !paused) return; paused = false; t0 = performance.now(); if (video) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); } tick(); }
  function pause() { if (paused) return; paused = true; acc += performance.now() - t0; cancelAnimationFrame(raf); if (video) video.pause(); }
  function stop() { paused = true; acc = 0; cancelAnimationFrame(raf); if (video) { video.pause(); video.removeAttribute('src'); video.load(); } }
  function tick() {
    if (paused) return;
    var e = acc + performance.now() - t0, pct = Math.min(e / dur, 1);
    if (curBar) curBar.style.width = (pct * 100) + '%';
    if (pct >= 1) { next(); return; }
    raf = requestAnimationFrame(tick);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-story]');
    if (!a) return;
    e.preventDefault(); open(a.dataset.story);
  });
  window.addEventListener('popstate', function () { if (opened && !(history.state && history.state.lsv)) close(true); });

  function prefetch() { if (!packs && !loading) load().catch(function () { loading = null; }); }
  function init() {
    paintSeen();
    document.querySelectorAll('[data-livo-stories]').forEach(function (r) {
      r.addEventListener('pointerenter', prefetch, { once: true });
      r.addEventListener('touchstart', prefetch, { once: true, passive: true });
    });
    if (document.querySelector('.livo-st--grid')) prefetch();
    var m = location.hash.match(/^#story=([\w-]+)/);
    if (m) { history.replaceState(null, '', location.pathname + location.search); open(m[1]); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.LivoStories = { open: open, close: close };
})();
